import { SceneObjectBase } from '../../core/SceneObjectBase.js';

class ConstantVariable extends SceneObjectBase {
  constructor(initialState) {
    super({
      type: "constant",
      value: "",
      name: "",
      ...initialState,
      skipUrlSync: true
    });
  }
  getValue() {
    return this.state.value;
  }
}

export { ConstantVariable };
//# sourceMappingURL=ConstantVariable.js.map
